var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm0 4.665a3.835 3.835 0 00-1.54 7.347c-.01-.267-.001-.589.067-.88l.494-2.09s-.123-.245-.123-.607c0-.568.33-.992.74-.992.348 0 .517.262.517.575 0 .351-.223.875-.339 1.361-.095.407.204.739.606.739.727 0 1.216-.933 1.216-2.039 0-.84-.566-1.47-1.596-1.47-1.163 0-1.888.868-1.888 1.837 0 .334.098.57.253.752.07.084.08.117.055.214l-.078.308c-.026.097-.104.131-.192.096-.536-.22-.785-.806-.785-1.465 0-1.09.918-2.396 2.74-2.396 1.464 0 2.428 1.06 2.428 2.197 0 1.504-.836 2.628-2.07 2.628-.413 0-.802-.224-.936-.478 0 0-.222.883-.27 1.054-.08.296-.24.591-.386.822A3.835 3.835 0 1012.5 8.665z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgPinterest;